<template>
  <div>
    <!-- 添加定制商品对话框 -->
    <el-dialog
      title="添加定制商品"
      :visible.sync="addDialogVisible"
      width="80%"
      append-to-body
      @close="addDialogClosed"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="rules"
        label-width="110px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="定制商品名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入定制商品名称" />
            </el-form-item>
          </el-col>
          <!--缩略图-->
          <el-col :span="24" class="label">
            <el-form-item label="缩略图">
              <thumbnail v-model="addForm.thumbnail" :md5s="addForm.thumbnail"></thumbnail>
            </el-form-item>
          </el-col>
          <!--轮播图-->
          <el-col :span="24" class="label">
            <el-form-item label="轮播图">
              <thumbnail-list v-model="addForm.carousel" :md5List="addForm.carousel"></thumbnail-list>
            </el-form-item>
          </el-col>
          <!--排序-->
          <el-col :span="24">
            <el-form-item label="排序" prop="sort">
              <el-input v-model="addForm.sort" placeholder="请输入排序"/>
            </el-form-item>
          </el-col>
          <!--说明-->
          <el-col :span="24">
            <el-form-item label="说明">
              <Editor v-model="addForm.brief"></Editor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button @click="addCustomGoods">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addCustomGoods } from '@/api/customGoods/customGoods'
import { getData } from '@/utils/code'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import Editor from '@/components/common/editor/editor'
import { customGoodsRules } from '@/js/rules'

export default {
  name: 'addCustomGoods',
  components: { Thumbnail, ThumbnailList, Editor },
  data() {
    return {
      addForm: {}, //添加组织表单
      addDialogVisible: false,
      rules: customGoodsRules
    }
  },
  methods: {
    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },
    addDialog() {
      this.addDialogVisible = true
    },
    // 监听添加对话框的关闭事件，重置表单
    addDialogClosed() {
      this.addForm = {}
    },
    // 添加
    addCustomGoods() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        addCustomGoods(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false
          }
        })
      })
    }

  }
}
</script>

<style scoped>

</style>
